export default "__VITE_ASSET__CGvBva2M__"